import { ArrowRight, Clock3, MapPin } from 'lucide-react';
import { EventCover } from './EventCover';
import { RecurrenceBadge, RegistrationBadge } from './EventMeta';
import { eventDetailHref, formatEventCardDate, type ChurchEvent } from '../lib/calendar';

export function EventCard({ event }: { event: ChurchEvent }) {
  const date = formatEventCardDate(event);
  const cover = event.images[0];
  const href = eventDetailHref(event);

  return (
    <a className="event-card reveal" href={href}>
      <EventCover
        src={cover}
        className="event-card-media"
        fallback={
          <div className="event-card-fallback" aria-hidden="true">
            <strong>{date.day}</strong>
            <span>{date.month}</span>
          </div>
        }
      >
        <time className="event-date-badge" dateTime={event.start.toISOString()}>
          <strong>{date.day}</strong>
          <span>{date.month}</span>
        </time>
      </EventCover>
      <div className="event-card-body">
        <div className="event-card-topline">
          <p className="event-card-meta">
            <span>
              <Clock3 size={15} aria-hidden="true" /> {date.weekday} · {date.time}
            </span>
          </p>
          <RecurrenceBadge event={event} />
          <RegistrationBadge event={event} />
        </div>
        <h3>{event.title}</h3>
        {event.excerpt && <p>{event.excerpt}</p>}
        {event.location && (
          <p className="event-card-location">
            <MapPin size={15} aria-hidden="true" /> {event.location}
          </p>
        )}
        <span className="event-card-action">
          Ver evento <ArrowRight size={16} aria-hidden="true" />
        </span>
      </div>
    </a>
  );
}
